import { NotificationOutlined } from '@ant-design/icons';
import {
  Badge as DotBadge,
  ListItemButton,
  ListItemIcon,
  Tooltip,
  Typography,
} from '@mui/material';
import { Badge } from '@trm/ui-kit-admin';

export const WhatsNewNavEntry = ({
  unreadCount,
  drawerOpen,
  onOpen,
}: {
  unreadCount: number;
  drawerOpen: boolean;
  onOpen: () => void;
}) => (
  <Tooltip title="What's new" placement="right" arrow disableHoverListener={drawerOpen}>
    <ListItemButton
      onClick={onOpen}
      aria-label={unreadCount > 0 ? `What's new, ${unreadCount} unread` : "What's new"}
      sx={{
        py: 1,
        pl: drawerOpen ? '28px' : 1.5,
        gap: 1,
        justifyContent: drawerOpen ? 'flex-start' : 'center',
        '&:hover': { bgcolor: 'primary.lighter' },
      }}
    >
      <ListItemIcon sx={{ minWidth: drawerOpen ? 28 : 0, color: 'text.primary' }}>
        <DotBadge color="primary" variant="dot" invisible={drawerOpen || unreadCount === 0}>
          <NotificationOutlined style={{ fontSize: drawerOpen ? '1rem' : '1.25rem' }} />
        </DotBadge>
      </ListItemIcon>
      {drawerOpen && (
        <Typography variant="h6" sx={{ flex: 1, fontWeight: 600 }}>
          What&apos;s new
        </Typography>
      )}
      {drawerOpen && unreadCount > 0 && (
        <Badge color="brand" size="sm">
          {unreadCount}
        </Badge>
      )}
    </ListItemButton>
  </Tooltip>
);
